import { defineMeta } from '@/registry/types';

export const appBarMeta = defineMeta({
  name: 'AppBar',
  level: 'organism',
  category: 'navigation',
  classification: 'mui-overrides',
  description: 'Top application bar for branding, search and global actions. Themed MUI AppBar.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'AppBar',
  muiDocs: 'https://mui.com/material-ui/react-app-bar/',
  a2uiEquivalent: 'Header',
  importPath: '@/organisms/AppBar',
  optionalProps: ['position', 'color', 'elevation'],
  supportedStates: ['static', 'sticky', 'fixed'],
  designTokens: ['colors', 'shadows', 'typography'],
  accessibility: ['Use a single banner landmark; provide aria-labels for icon buttons.'],
  usageExamples: [
    '<AppBar position="static"><Toolbar><Typography variant="h6">Octopus</Typography></Toolbar></AppBar>',
  ],
  rules: ['The product name in the bar is `Typography variant="h6"` (or subtitle1 on a compact bar).'],
  antiPatterns: ['Do not stuff primary navigation into the AppBar (use LeftNavigation).'],
  llmSafe: true,
  whenToUse: ['Global top bar', 'Branding + search + user menu'],
  whenNotToUse: ['Section headers (use Typography/Toolbar)'],
});

export default appBarMeta;
